import { Card, Divider, Form, Input } from "antd";
import { SwitchChangeEventHandler } from "antd/es/switch";
import { FC, useState } from "react";
import CustomerInfoFormItems from "../../../../components/customerInfoFormItems";
import FancySubmitButton from "../../../../components/fancySubmitButton";
import AdminSelectDealerUser from "../../../../components/form/adminUserSelect";
import EnumRadio from "../../../../components/form/EnumRadio";
import SwitchInput from '../../../../components/form/switchInput';
import LoadingContainer from "../../../../components/loadingContainer";
import ServerSelectBox from "../../../../components/serverSelectBox";
import { useEnums } from "../../../../components/useEnum";
import _t from "../../../../lang/translate";
import { customersAutoComplete, } from "../../../../services/autocompleteService";
import consts from "../../../../utilities/consts";

const { TextArea } = Input;

interface TaxNewCaseAdminPanelProps {
  loading: boolean;
  caseType?: "MOTOR_KOMPAGNIET" | "TAX"
  hideCard?: boolean;
  hideSubmitBtn?: boolean;
}

const TaxNewCaseAdminPanel: FC<TaxNewCaseAdminPanelProps> = (props) => {

  return props.hideCard ? (
    <Inner {...props} />
  ) : (
    <Card style={{ boxShadow: "none" }} bordered={false} title={_t("case_created_for")}>
      <Inner {...props} />
    </Card>
  );
};

function Inner({ loading, caseType, hideSubmitBtn }: TaxNewCaseAdminPanelProps) {
  const [isNewCustomer, setIsNewCustomer] = useState<boolean>(false);
  const handleIsNewCustomer: SwitchChangeEventHandler = (checked, _e) => {
    setIsNewCustomer(checked);
  }
  return (
    <>
      <LoadingContainer loading={loading}>

        {caseType === "MOTOR_KOMPAGNIET" ? (
          <>
            <Form.Item>
              <SwitchInput
                label={_t('new_customer')}
                checked={isNewCustomer}
                onChange={handleIsNewCustomer}
              />
            </Form.Item>

            {isNewCustomer ? (
              <ManualCustomerCreationFormItems />
            ) : (
              <AdminUserSelect />
            )}
          </>
        ) : (
          <AdminUserSelect />
        )}
        <Divider />
        <Form.Item {...consts.formItemLabellessProps} name="paymentMethodId" rules={[{ required: true }]}>
          <EnumRadio nameKey={["paymentMethod"]} />
        </Form.Item>
        <Form.Item {...consts.formItemLabellessProps} name="reason">
          <TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="Første sag rabat.." />
        </Form.Item>
      </LoadingContainer>
      {!hideSubmitBtn && (
        <div className="fancy-btn-wp text-center">
          <FancySubmitButton loading={loading} />
        </div>
      )}
    </>
  )
}


export default TaxNewCaseAdminPanel;

const AdminUserSelect = () => {
  const [clientType] = useEnums(["client", "type"]);

  return (
    <>
      <Form.Item noStyle shouldUpdate={(curr, next) => curr.client.typeId !== next.client.typeId}>
        {({ setFieldsValue }) => {
          return (
            <Form.Item {...consts.formItemLabellessProps} name={["client", "typeId"]}>
              <EnumRadio
                nameKey={["client", "type"]}
                onChange={(e) => setFieldsValue({ calculationTypeId: e.target.value })}
              />
            </Form.Item>
          );
        }}
      </Form.Item>

      <AdminSelectDealerUser />

      <Form.Item noStyle shouldUpdate={(prev, curr) => prev.client.typeId !== curr.client.typeId}>
        {({ getFieldValue }) => {
          const typeId = getFieldValue(["client", "typeId"]);
          return (
            clientType &&
            typeId === clientType[1]?.id && (
              <Form.Item
                {...consts.formItemLabellessProps}
                name={["client", "customerId"]}
                rules={[{ required: true }]}
              >
                <ServerSelectBox apiUrl={customersAutoComplete()} placeholder={_t("choose", "customer")} serverSideFilter pageSize={999} urlSetDelay={300} />
              </Form.Item>
            )
          );
        }}
      </Form.Item>
      <Form.Item {...consts.formItemLabellessProps} name="calculationTypeId">
        <EnumRadio nameKey={["taxCase", "calculationType"]} />
      </Form.Item>
    </>
  );
};


function ManualCustomerCreationFormItems() {
  return (
    <Form.Item wrapperCol={{ span: 24 }} className={"ant-form-vertical"}>
      <CustomerInfoFormItems namePrefix={"customerData"} />
    </Form.Item>
  )
}
